import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="relative rounded-2xl overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20copper%20and%20dark%20elegant%20abstract%20gradient%20background%20with%20soft%20flowing%20lines%2C%20professional%20corporate%20feel%2C%20minimalist%20geometric%20texture%2C%20luxurious%20and%20warm%20atmosphere%2C%20no%20people&width=1200&height=500&seq=cta-bg-2026&orientation=landscape"
            alt="合规指引CTA背景"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-primary-800/70"></div>
        <div className="relative z-10 flex flex-col items-center text-center px-6 py-14 md:py-20">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
            开始您的合规学习之旅
          </h2>
          <p className="text-sm md:text-base text-background-200/80 max-w-lg mb-8">
            无论您是普通用户还是行业从业者，我们都能为您提供专业的合规指引和安全建议
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/falv-fagui"
              className="px-6 py-3 bg-background-50 text-primary-700 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              浏览文章
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 border border-background-50/30 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}